$('#frm_import_lots').on('submit', function(e) {
    e.preventDefault();
    $.ajax({
        type: "POST",
        url: $('#frm_import_lots').attr('action'),
        dataType: 'json',
        data: $('#frm_import_lots').serialize() + '&action=importlots'
    }).done(function(data) {
        if( data.success ) {
            $('#lots_list').html(data.content);
            $.fancybox.close();
            $('html, body').animate({scrollTop: $('#lots_list').offset().top }, 10);
        } else {
            $('#frm_import_lots .msg').html(data.msg);
        }
    });
});

$('._btn_import_lots').each(function(i, el) {
    createImportLotsUploader(el);
});

import ss from 'simple-ajax-uploader';
function createImportLotsUploader(el) {
    var $target = $(el).is('[data-target]') ? $($(el).data('target')) : $(el).next();
    var imageuploader = new ss.SimpleUpload({
        button: $(el),
        url: $(el).data('url'),
        name: 'uploadfile',
        multiple: false,
        multipleSelect: false,
        hoverClass: 'hover',
        focusClass: 'hover',
        progressUrl: $(el).data('progress'),
        responseType: 'json',
        allowedExtensions: ['xlsx'],
        onChange: function( filename, extension, uploadBtn, fileSize, file ) {
            $('.alert', $target).remove();
        },
        onSubmit: function(filename, extension, uploadBtn, fileSize) {
            $('.alert', $target).remove();
            $target.prepend('<div class="progress"><div class="progress-bar" role="progressbar" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100"></div></div>');
            var wrapper = $('.progress', $target).get(0);
            this.setProgressContainer(wrapper);
            this.setProgressBar( $('.progress-bar', wrapper).get(0) );
            this.setPctBox( $('.progress-bar', wrapper).get(0) );
        },
        onExtError: function( filename, extension ) {
            $target.prepend('<div class="alert alert-danger alert-dismissible fade show" role="alert">' + __str('Type de fichier non autorisé (xlsx)') + '<button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button></div>');
                return false;
        },
        onSizeError: function( filename, fileSize ) {
            $target.prepend('<div class="alert alert-danger alert-dismissible fade show" role="alert">' + __str('Le fichier est trop volumineux') + '<button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button></div>');
                return false;
        },
        onComplete: function(filename, response) {
            if(!response) {
                $target.prepend('<div class="alert alert-danger alert-dismissible fade show" role="alert">' + __str('Une erreur est survenue lors de l\'upload du fichier') + '<button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button></div>');
                return false;
            }
            else {
                if(response.success) {
                    $.ajax({
                        type: "POST",
                        dataType: 'json',
                        data: 'file=' + response.file + '&action=processimportlotsfile'
                    }).done(function(data) {
                        if ( data.success ) {
                            console.log(data.values[0]);

                            var fields = {
                                'num': 'Numéro',
                                'num_copro': 'Numéro copro',
                                'montant_charges_copro': 'Montant charges de copro (Annuel)',
                                'montant_charges_copro_parking': 'Montant charges de copro Parking (Annuel)',
                                'type': 'Type',
                                'batiment': 'Bâtiment',
                                'typologie': 'Typologie',
                                'surface': 'Surface habitable',
                                'surface_utile': 'Surface utile',
                                'etage': 'Étage',
                                'orientation': 'Orientation',
                                'num_parking': 'N° de Parking',
                                'num_parking_copro': 'N° de Parking copro',
                                'nb_parking': 'Nombre de Parking',
                                'surface_parking': 'Surface Parking',
                                'surface_balcon': 'Surface Balcon/Loggia',
                                'surface_jardin': 'Surface Jardin',
                                'surface_cellier': 'Surface Cellier',
                                'prix_base_ht': 'Prix de base HT',
                                'prix_base_tva': 'Taux de TVA',
                                'prix_base_tva_montant': 'Montant TVA',
                                'prix_base_ttc': 'Prix de base TTC',
                            };

                            var content = '<p><strong>Correspondance des champs</strong></p>';
                            content += '<table class="table table-sm">';
                            for ( var i = 0; i < data.values[0].length; i++ ) {
                                if ( data.values[0][i] == '' ) {
                                    continue;
                                }
                                content += '<tr>';
                                content += '<td>' + data.values[0][i] + '</td>';
                                content += '<td>';
                                content += '<select class="form-control" name="fields[' + i + ']">';
                                content += '<option value="">Ne pas utiliser</option>';
                                for ( const [key, value] of Object.entries(fields) ) {
                                    let selected = false;
                                    if ( data.values[0][i] == value ) {
                                        selected = true;
                                    } else {
                                        switch ( key ) {
                                            case 'num': selected = ( data.values[0][i] == 'N°Lot' || data.values[0][i] == 'Lot' ); break;
                                            case 'batiment': selected = ( data.values[0][i] == 'Bat' ); break;
                                            case 'typologie': selected = ( data.values[0][i] == 'Typo' ); break;
                                            case 'surface': selected = ( data.values[0][i] == 'Surface hab' ); break;
                                            case 'surface_utile': selected = ( data.values[0][i] == 'SU' ); break;
                                            case 'etage': selected = ( data.values[0][i] == 'Etage' ); break;
                                            case 'orientation': selected = ( data.values[0][i] == 'Expo' ); break;
                                            case 'surface_balcon': selected = ( data.values[0][i] == 'Balcon' || data.values[0][i] == 'Terrasse' ); break;
                                            case 'prix_base_ht': selected = ( data.values[0][i] == 'HT' ); break;
                                            case 'prix_base_tva_montant': selected = ( data.values[0][i] == 'TVA' ); break;
                                            case 'prix_base_ttc': selected = ( data.values[0][i] == 'PV proposition AXANIS' ); break;
                                        }
                                    }
                                    content += '<option value="' + key + '"' + ( selected ? ' selected' : '' ) + '>' + value + '</option>'; 
                                }
                                content += '</select>';
                                content += '</td>';
                                content += '</tr>';
                            }
                            content += '</table>';
                            content += '<textarea class="form-control d-none" name="values">' + JSON.stringify(data.values) + '</textarea>';
                            content += '<div class="msg"></div><div class="mt-3"><button type="submit" name="action" value="importlots" class="btn btn-success"><i class="material-icons">check</i><span>Importer</span></button><button type="button" data-fancybox-close class="btn btn-white ml-3"><span>Annuler</span></button></div>';
                            $target.html(content);
                        } else {
                            $target.prepend('<div class="alert alert-danger alert-dismissible fade show" role="alert">Erreur de traitement du fichier<button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button></div>');
                        }
                    });
                }
                else {
                    $target.prepend('<div class="alert alert-danger alert-dismissible fade show" role="alert">' + __str('Une erreur est survenue lors de l\'upload du fichier') + response.file + '<br>' + response.msg + '<button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button></div>');
                    return false;
                }
            }
        }
    });
}